module.exports = __webpack_public_path__ + "static/media/finance.a3067473.svg";